import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, Button, InputGroup, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import UploadImageComponent from "../UploadImageComponent";
import imgConfirm from "../../assets/image-confirm.png";
import convertNumber from "../../helpers/convertNumber";
import convertTypeDepositWithdraw from "../../helpers/convertTypeDepositWithdraw";
import converSex from "../../helpers/convertSex";
export default function PopUpConfirmDepositAndWithdraw({
  open,
  onClose,
  formData,
  onSubmit,
}) {
  // state
  const [disableButton, setDisableButton] = useState(false);

  // function

  return (
    <Modal show={open} onHide={onClose} backdrop="static" size="md">
      <Modal.Body
        style={{
          boxSizing: "border-box",
          overflow: "auto",
          width: "100%",
          padding: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h1 style={{ color: "#343A40", fontSize: 20, fontWeight: 700 }}>
            ຢືນຢັນ
          </h1>
          <p style={{ color: "#6C757D", fontSize: 16 }}>
            ກະລຸນາກວດສອບຂໍ້ມູນອີກຄັ້ງກ່ອນຢືນຢັນ
          </p>
        </div>
        <div style={{ display: "flex", justifyContent: "center", padding: 16 }}>
          <img src={imgConfirm} alt="" style={{ width: "150px" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 20,
            marginBottom: 20,
          }}
        >
          {[
            { title: "ຊື່ ແລະ ນາມສະກຸນ:", value: formData?.fullName || "-" },
            {
              title: "ເພດ:",
              value: formData?.gender ? converSex(formData?.gender) : "-",
            },
            {
              title: "ປະເພດທຸລະກຳ:",
              value: formData?.type
                ? convertTypeDepositWithdraw(formData?.type, true)
                : "-",
            },
            {
              title: "ຍອດຄົງເຫຼືອກ່ອນໜ້າ (ກີບ):",
              value: formData?.balanceId?.totalBalance
                ? convertNumber(formData?.balanceId?.totalBalance)
                : "-",
            },
            {
              title: "ຈຳນວນເງິນ (ກີບ):",
              value: formData?.balanceAmount
                ? convertNumber(formData?.balanceAmount)
                : "-",
            },
            // { title: "ຍອດຄົງເຫຼືອກ່ອນໜ້າ (ກີບ):", value: "-" },
            {
              title: "ຍອດເງິນລວມ (ກີບ):",
              value:
                formData?.type === "WITHDRAW"
                  ? convertNumber(
                      parseInt(formData?.balanceId?.totalBalance) -
                        parseInt(formData?.balanceAmount)
                    )
                  : convertNumber(
                      parseInt(formData?.balanceId?.totalBalance) +
                        parseInt(formData?.balanceAmount)
                    ),
            },

            {
              title: "ຄະແນນ:",
              value: formData?.balanceId?.totalPoint
                ? convertNumber(formData?.balanceId?.totalPoint)
                : "-",
            },
            { title: "ລາຍລະອຽດ:", value: formData?.description || "-" },
          ].map((e, i) => (
            <div className="list-data" key={i}>
              <div>{e?.title}</div>
              <div>{e?.value}</div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer style={{ marginBottom: 30 }}>
        <div style={{ width: "100%", display: "flex", gap: 10 }}>
          <Button
            variant="outline-primary"
            style={{ flex: 1 }}
            onClick={onClose}
          >
            ແກ້ໄຂ
          </Button>
          <Button
            disabled={disableButton}
            style={{ flex: 1 }}
            onClick={() => {
              setDisableButton(true);
              onSubmit().then(() => {
                setDisableButton(false);
              });
            }}
          >
            ຢືນຢັນ
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
